import { ReviewFindResponseBodyReviewsDto } from '../api/reviews';
import { ReviewListRequestType } from '../../views/cs/review/common/types/ReviewListType';
import { SearchOption } from '../common/table';

export class ReviewItemV2 {
  url?: string | null;
  rate: number;
  id: number;
  content: string;
  brandId: number;
  brandName: string;
  productId: number;
  productName: string;
  createDate: string;

  constructor(item: ReviewFindResponseBodyReviewsDto) {
    this.url = item.reviewAttachments[0]?.url;
    this.rate = item.rate;
    this.id = item.id;
    this.content = item.content;
    this.brandId = item.store.id;
    this.brandName = item.store.name;
    this.productId = item.product.id;
    this.productName = item.product.name;
    this.createDate = item.createDate;
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-unsafe-declaration-merging
export interface ReviewListRequestOptionV2 extends ReviewListRequestType {}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export class ReviewListRequestOptionV2 {
  constructor(
    option: SearchOption<
      Partial<Pick<ReviewItemV2, 'id' | 'content' | 'rate' | 'brandId' | 'brandName' | 'productId' | 'productName'>>
    >,
  ) {
    this.id = option.id;
    this.page = option.page;
    this.pageSize = option.pageSize;
    this.rate = option.rate;
    this.content = option.content;
    this.storeId = option.brandId;
    this.storeName = option.brandName;
    this.productId = option.productId;
    this.productName = option.productName;
    this.sort = option.sort?.join(',');
  }
}
